import { useAuthStore } from "@/lib/auth/AuthStore";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { SHOP_CHECKOUT_PAGE } from "@/settings/constant";
import { useRouter } from "next/router";
import { useCallback } from "react";
import LoginDialog from "src/store/loginDialog";
/**
 * 이용권 구매 액션 helper — mixpanel + 미로그인 분기 + /checkout 푸시.
 *
 * 엑스퍼트 카테고리의 "보유 쏠북플러스 사전 체크" 같은 호출처 고유 분기는 본 helper 가 다루지 않는다.
 * 호출처가 그 분기를 먼저 처리하고, 통과 시 본 helper 를 호출한다.
 *
 * redirectPath 흐름은 손대지 않는다 — `usePassStore.redirectPath` 는 `/passes/[pageType]` 진입 시
 * URL query 로부터 set 되어 있고, `/checkout` 푸시 후에도 store 에 보존된 채 결제 페이지로 흐른다.
 */ export const usePurchasePassAction = ()=>{
    const router = useRouter();
    const { isLoggedIn  } = useAuthStore();
    const { openLoginDialog  } = LoginDialog();
    return useCallback((pass)=>{
        mixpanelEvent("Purchase Button Clicked", {
            "Product Categories": pass.category,
            "Product ID": pass.id,
            "Product Title": pass.title,
            "Product Price": pass.price
        });
        if (!isLoggedIn) {
            openLoginDialog();
            return;
        }
        router.push("".concat(SHOP_CHECKOUT_PAGE, "?id=").concat(pass.id, "&orderType=pass"));
    }, [
        isLoggedIn,
        openLoginDialog,
        router
    ]);
};
